import { Fragment } from 'react';
import {
  Box,
  Divider,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  ListSubheader,
  Toolbar,
  Typography,
} from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import { MENU_ITEMS } from '@/menus';
import { useConfig } from '@/context/ConfigProvider';
import BuildInfo from '@/components/BuildInfo';
import { drawerWidth } from './constants';

const MenuDrawer = () => {
  const config = useConfig();
  const { pathname } = useLocation();

  return (
    <Drawer
      variant="permanent"
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        [`& .MuiDrawer-paper`]: { width: drawerWidth, boxSizing: 'border-box' },
      }}
    >
      <Toolbar />
      <Box sx={{ overflow: 'auto', flexGrow: 1 }}>
        <List>
          {Object.entries(MENU_ITEMS).map(([key, item], index, all) => {
            // A heading before the first item of each group, so the daily-use screens stay visually
            // separate from administration rather than reading as one long list.
            const previousGroup =
              index > 0 ? all[index - 1][1].group : undefined;
            const startsGroup = item.group && item.group !== previousGroup;

            return (
              <Fragment key={key}>
                {startsGroup && (
                  <>
                    <Divider sx={{ my: 1 }} />
                    <ListSubheader
                      disableSticky
                      sx={{ bgcolor: 'transparent' }}
                    >
                      {item.group}
                    </ListSubheader>
                  </>
                )}
                <ListItem disablePadding>
                  <ListItemButton
                    component={Link}
                    to={item.path}
                    selected={pathname.startsWith(item.path)}
                  >
                    <ListItemIcon>
                      <item.icon />
                    </ListItemIcon>
                    <ListItemText primary={item.displayName} />
                  </ListItemButton>
                </ListItem>
              </Fragment>
            );
          })}
        </List>
      </Box>
      <Divider />
      <Box sx={{ p: 2 }}>
        <Typography variant="caption" color="text.secondary" display="block">
          Environment: {config.env}
        </Typography>
        <BuildInfo />
      </Box>
    </Drawer>
  );
};

export default MenuDrawer;
